(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('cookiepolicy', {
                parent: 'app',
                url: '/cookiepolicy',
                data: {
                    authorities: [],
                    pageTitle: 'Cookie Policy'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/cookiepolicy/cookiepolicy.html'
                    }
                }
            });
    }
})();
